var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3044_1425)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.83997C0 2.97397 3.13401 -0.160034 7 -0.160034H17C20.866 -0.160034 24 2.97397 24 6.83997V16.84C24 20.706 20.866 23.84 17 23.84H7C3.13401 23.84 0 20.706 0 16.84V6.83997ZM7 1.83997C4.23858 1.83997 2 4.07854 2 6.83997V16.84C2 19.6014 4.23858 21.84 7 21.84H17C19.7614 21.84 22 19.6014 22 16.84V6.83997C22 4.07854 19.7614 1.83997 17 1.83997H7Z",
    fill: "#D54682"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11.34C18 11.6822 17.825 12.0006 17.5361 12.1841L10.0361 16.9473C9.72815 17.1428 9.33811 17.1552 9.01839 16.9795C8.69867 16.8038 8.5 16.4679 8.5 16.1031V6.57683C8.5 6.21201 8.69867 5.87614 9.01839 5.70044C9.33811 5.52474 9.72815 5.53709 10.0361 5.73268L17.5361 10.4958C17.825 10.6793 18 10.9977 18 11.34ZM10.5 8.39653V14.2834L15.1347 11.34L10.5 8.39653Z",
    fill: "#D54682"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3044_1425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.8a6994406946156e46f7fc8d61ffcc44.svg";
export { ForwardRef as ReactComponent };